<template>
  <el-drawer title="发起审批" :visible.sync="drawer" :modal-append-to-body="false" append-to-body destroy-on-close :wrapperClosable="false" custom-class="widthCommon">
    <el-form ref="addForm" status-icon :model="addForm" :rules="rules" label-position="left" label-width="83px" size="small" class="mx-20-1 bg-#fff py-20 pr-30">
      <el-form-item label="开始日期：" prop="beginTime">
        <el-date-picker v-model="addForm.beginTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始日期" style="width: 100%"></el-date-picker>
      </el-form-item>
      <el-form-item label="结束日期：" prop="endTime">
        <el-date-picker v-model="addForm.endTime" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束日期" style="width: 100%"></el-date-picker>
      </el-form-item>
      <el-form-item label="用章事由：" prop="useReason">
        <el-input v-angle="addForm.useReason" v-model="addForm.useReason" placeholder="填写用章事由" :rows="4" maxlength="70" type="textarea" show-word-limit clearable />
      </el-form-item>
      <el-form-item label="附件：" prop="annexUrl" label-width="73px" style="margin-left: 10px">
        <el-upload
          class="flex items-start flex-column"
          accept=".jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf"
          :action="`/api/estate/v1/common/uploadFile?token=${token}&communityId=0`"
          :on-success="handleSuccess"
          :on-remove="handleRemove"
          multiple
          :limit="3"
        >
          <el-button size="small" type="primary" class="mr-8">选择附件</el-button>
        </el-upload>
        <div class="el-upload__tip">最多3个，不超过2M，格式为jpg/jpeg/png/doc/docx/xls/xlsx/pdf</div>
      </el-form-item>
    </el-form>
    <FixedTwoButton activeClass="widthCommon">
      <ELButton size="small" describe="重置" :myFunction="resetForm" />
      <ELButton size="small" describe="提交" isAsync :myFunction="submitForm" type="primary" />
    </FixedTwoButton>
  </el-drawer>
</template>

<script>
import { getToken } from '@/utils/auth'
import { flowUseSealIns } from '@/api/workflow'

export default {
  inject: ['indexThis'],
  data() {
    return {
      drawer: false,
      addForm: {
        beginTime: '',
        endTime: '',
        useReason: '',
        annexUrl: [],
      },
      rules: {
        beginTime: [{ required: true, message: '开始日期不能为空', trigger: 'change' }],
        endTime: [{ required: true, message: '结束日期不能为空', trigger: 'change' }],
        useReason: [{ required: true, message: '用章事由不能为空', trigger: 'change' }],
      },
    }
  },
  computed: {
    token() {
      return getToken()
    },
  },
  watch: {
    drawer(val) {
      if (!val) this.resetForm()
    },
  },
  methods: {
    async submitForm() {
      const valid = await this.$refs.addForm.validate().catch(() => {})
      if (!valid) return false
      const { data: res } = await flowUseSealIns(this.addForm)

      if (!res) return this.$message.error('发起失败')
      this.$message.success('发起成功')
      this.indexThis.init()
      this.resetForm()
      this.drawer = false
    },
    resetForm() {
      this.$refs.addForm.resetFields()
    },

    // 移除上传的文件
    handleRemove(file, fileList) {
      this.addForm.annexUrl = fileList.map(item => item.response.data.visitUrl)
    },

    handleSuccess(res, file, fileList) {
      if (res.errCode !== 0) {
        this.handleRemove(file, fileList)
        return this.$message.error(res.errMsg)
      }
      this.addForm.annexUrl = fileList.map(item => item.response.data.visitUrl)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-select {
  width: 100% !important;
}
::v-deep .el-upload {
  width: auto !important;
  height: auto !important;
  border: none !important;
}
.el-upload__tip {
  color: #606266 !important;
  margin-top: 0 !important;
}
</style>
